'use client';

import { classes } from '@/uiPrimitives/base/classes.helpers';
import { zIndex } from '@/uiPrimitives/layout/zIndex.css';
import { ReactNode } from 'react';
import {
	ScrollInline,
	scrollInlineTranslations,
	scrollLeft,
	scrollRight,
} from './ScrollInline';
import {
	measureAfter,
	measureBefore,
	scrollInlineWrapper,
} from './ScrollInline.css';
import { useShowScrollButtons } from './useShowScrollButtons';
import { block } from '@/uiPrimitives/utility/display.css';
import { ScrollButton } from './ScrollButton';

export const ScrollInlineWithBigButtons = ({
	children,
	className,
	scrollAreaClassName,
	scrollRatio = 2 / 3,
}: {
	className?: string;
	scrollAreaClassName?: string;
	scrollRatio?: number;
	children?: ReactNode;
}) => {
	const {
		measureBeforeRef,
		measureAfterRef,
		scrollAreaRef,
		showBeforeButton,
		showAfterButton,
	} = useShowScrollButtons();

	return (
		<span
			className={classes(
				className,
				scrollInlineWrapper,
				zIndex({ isolation: 'isolate' }),
			)}
		>
			<ScrollInline
				scrollAreaClassName={classes(scrollAreaClassName)}
				ref={scrollAreaRef}
				measureBeforeSlot={
					<i className={classes(measureBefore)} ref={measureBeforeRef} />
				}
				measureAfterSlot={
					<i className={classes(measureAfter)} ref={measureAfterRef} />
				}
				scrollbarWidth="thin"
				notOverflowing={showBeforeButton === false && showAfterButton === false}
				mask={
					showBeforeButton && showAfterButton
						? 'both'
						: showBeforeButton
							? 'before'
							: showAfterButton
								? 'after'
								: undefined
				}
			>
				<span className={classes(block)}>{children}</span>
			</ScrollInline>

			<ScrollButton.Shelf>
				<ScrollButton.Item
					side="before"
					isShowing={showBeforeButton ?? false}
					buttonLabel={
						scrollInlineTranslations['Scroll left in previous scroll area']
					}
					onClick={() => {
						const scrollAreaElement = scrollAreaRef.current;
						if (scrollAreaElement == null) return;

						scrollLeft(scrollAreaElement, scrollRatio);
					}}
				/>
				<ScrollButton.Item
					side="after"
					isShowing={showAfterButton ?? false}
					buttonLabel={
						scrollInlineTranslations['Scroll right in previous scroll area']
					}
					onClick={() => {
						const scrollAreaElement = scrollAreaRef.current;
						if (scrollAreaElement == null) return;

						scrollRight(scrollAreaElement, scrollRatio);
					}}
				/>
			</ScrollButton.Shelf>
		</span>
	);
};
